import React from "react";
import { Col, Form, Input, Row } from "antd";
import { useSelector } from "react-redux";
import CustomInput from "../../shared/form/reactHookForm/CustomInput";

const leftLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const rightLayout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};

const CompanyGeneralPanel = ({ control }) => {
  const data = useSelector((state) => state.company.data);

  return (
    <Form size="small" layout="horizontal">
      <Row gutter={32}>
        {/* Left Column - Name & Address */}
        <Col span={14}>
          <CustomInput
            control={control}
            layout={leftLayout}
            hasFeedback={true}
            required={true}
            formLabel="Name"
            name="CompanyName"
          />
          <CustomInput
            control={control}
            layout={leftLayout}
            hasFeedback={true}
            required={true}
            formLabel="Address 1"
            name="Address1"
          />
          <CustomInput
            control={control}
            layout={leftLayout}
            hasFeedback={true}
            formLabel="Address 2"
            name="Address2"
          />
          <Row>
            <Col span={12}>
              <CustomInput
                control={control}
                layout={{ labelCol: { span: 12 }, wrapperCol: { span: 12 } }}
                hasFeedback={true}
                required={true}
                formLabel="City"
                name="City"
              />
            </Col>
            <Col span={6}>
              <CustomInput
                control={control}
                layout={{ labelCol: { span: 16 }, wrapperCol: { span: 8 } }}
                hasFeedback={true}
                required={true}
                formLabel="Province"
                name="StateProvinceCode"
              />
            </Col>
            <Col span={6}>
              <CustomInput
                control={control}
                layout={{ labelCol: { span: 14 }, wrapperCol: { span: 10 } }}
                hasFeedback={true}
                required={true}
                formLabel="Postal Code"
                name="ZipPostalCode"
              />
            </Col>
          </Row>
        </Col>

        {/* Right Column - Read-only stats */}
        <Col span={10}>
          <Form.Item {...rightLayout} label="Active Download Agencies">
            <Input
              value={data?.ActiveDownloadAgencyCount ?? 0}
              disabled
              style={{ width: 80 }}
            />
          </Form.Item>
          <Form.Item {...rightLayout} label="Avg Monthly Transactions">
            <Input
              value={data?.AvgMonthlyTransactions ?? 0}
              disabled
              style={{ width: 80 }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CompanyGeneralPanel;